// src/hooks/useOnlineStatus.ts

import { useEffect, useState } from 'react';
import { useAppStore } from '../store/appStore';

/**
 * Custom hook that tracks online/offline status.
 * Updates the Zustand store's `isOffline` state and returns current `isOnline` boolean.
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const setOffline = useAppStore((state) => state.setOffline);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setOffline(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setOffline(true);
    };

    // Sync initial state to store
    setOffline(!navigator.onLine);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setOffline]);

  return isOnline;
}
